import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import {
  CreateFeedbackNoteReq,
  ErrorResponseType,
  FeedbackNote,
} from '../types';

const getNotesCode = import.meta.env.VITE_GET_FEEDBACK_NOTES;
const createNoteCode = import.meta.env.VITE_CREATE_FEEDBACK_NOTE;
const updateNoteCode = import.meta.env.VITE_UPDATE_FEEDBACK_NOTE;
const deleteNoteCode = import.meta.env.VITE_DELETE_FEEDBACK_NOTE;
const summaryCode = import.meta.env.VITE_GENERATE_FEEDBACK_SUMMARY;

// get the logged-in mentor's notes for a mentee (optionally scoped to a quarter)
export const getFeedbackNotes = async (menteeId: string, quarterId?: string) => {
  const ret: { data: FeedbackNote[]; error: ErrorResponseType | null } = {
    data: [],
    error: null,
  };
  try {
    const { data } = await axios.get(
      `${apiPaths.feedbackNotes}?menteeId=${menteeId}${quarterId ? `&quarterId=${quarterId}` : ''}&code=${getNotesCode}`
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const createFeedbackNote = async (payload: CreateFeedbackNoteReq) => {
  const ret: { data?: FeedbackNote; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.feedbackNotes}?code=${createNoteCode}`,
      payload
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const updateFeedbackNote = async (id: string, noteText: string) => {
  const ret: { data?: FeedbackNote; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.put(
      `${apiPaths.feedbackNotes}/${id}?code=${updateNoteCode}`,
      { noteText }
    );
    if (data) ret.data = data;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

export const deleteFeedbackNote = async (id: string) => {
  const ret: { error: ErrorResponseType | null } = { error: null };
  try {
    await axios.delete(`${apiPaths.feedbackNotes}/${id}?code=${deleteNoteCode}`);
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};

// asks the backend to draft feedback from the notes for one objective; the notes stay server-side
export const generateFeedbackSummary = async (
  menteeId: string,
  quarterId?: string,
  objectiveId?: string
) => {
  const ret: { data?: string; error: ErrorResponseType | null } = {
    error: null,
  };
  try {
    const { data } = await axios.post(
      `${apiPaths.feedbackSummary}?code=${summaryCode}`,
      { menteeId, quarterId, objectiveId }
    );
    if (data && typeof data.summary === 'string') ret.data = data.summary;
    else ret.error = errMsgNoData();
    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
